module.exports = __webpack_public_path__ + "img/welfare-permanentactivity.bdef7711.png";